/* Session types and helpers. All session data comes from the Scheduler API
 * (src/lib/scheduler.server.ts); there is no hardcoded schedule. */

export interface ScheduledSession {
  id: string;
  courseSlug: string; // must match a slug in courses.ts
  startDate: string; // ISO "2026-09-15"
  endDate?: string;
  time: string; // "1:00 PM - 2:00 PM ET"
  format: string; // "Virtual"
  seatsNote?: string;
  registerUrl?: string;
  /** Training Pipeline course id (live sessions). */
  courseId?: number;
  startTime?: string; // "9:00 AM"
  endTime?: string;
  /** Every meeting date in the cohort (live sessions). */
  meetingDates?: string[];
  instructor?: string;
  /** Training Pipeline session id for each meeting; the buyer is enrolled in all. */
  tpSessionIds?: number[];
}

/** Today's date as ISO "YYYY-MM-DD" (local). */
function todayIso(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** A session is registrable while its start date has not passed. */
export function isUpcoming(s: ScheduledSession): boolean {
  return s.startDate >= todayIso();
}

/** Registrable sessions from a list, soonest first. */
export function upcomingFrom(list: ScheduledSession[]): ScheduledSession[] {
  return list.filter(isUpcoming).sort((a, b) => a.startDate.localeCompare(b.startDate));
}
